// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./gdpr.styl");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../node_modules/style-loader/addStyles.js")(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./gdpr.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./gdpr.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/GDPR-popups/stylus/gdpr.styl
// module id = 633
// module chunks = 2